<template>
  <div style="height: 30vh">
    <div class="title" style="height: 10%">D1 Establish the Team</div>
    <div style="height: 90%;" class="bad-scroll">
      <table class="table-wrapper">
        <thead>
          <tr style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
            <th style="width:33%">Team</th>
            <th style="width:33%">Department</th>
            <th style="width:33%">Name</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(team,i) in dataList">
            <tr style="height:4vh;">
              <td>
                <span v-if="i == 0">组长</span>
                <span v-if="i != 0">组员</span>
              </td>
              <td><span v-if="team.department">{{ team.department.title }}</span></td>
              <td>{{ team.name }}</td>
            </tr>
          </template>
          <template v-if="dataList.length < 8">
            <tr style="height:4vh;" v-for="(team, i) in (8 - dataList.length)" :key="i">
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "fr1d",
  props: {
    bean: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    bean: {
      handler: function (val, oldVal) {
        if (val["teams"]) {
          this.dataList = val["teams"];
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      dataList: [],
      startCharts: null,
    };
  },
  mounted() { },
  methods: {
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>
<style scoped>
.title {
  width: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
  font-weight: bold;
  text-align: left;
  font-size: 15px;
  z-index: 1;
  text-shadow: 0 0 5px #fff, 0 0 35px #33ccff, 0 0 45px #33ccff,
    0 0 50px #33ccff;
}

.table-wrapper {
  width: 100%;
  border-collapse: collapse;
  border-top: 1px solid #2c7be8;
  border-right: 1px solid #2c7be8;
}

.table-wrapper>thead {
  position: sticky;
  top: 0;
}

.table-wrapper>thead>tr>th {
  border-bottom: 1px solid #2c7be8;
  border-left: 1px solid #2c7be8;
  color: white;
  padding: 4px 0;
  font-size: 15px;
}

.table-wrapper>tbody>tr>td {
  border-bottom: 1px solid #2c7be8;
  border-left: 1px solid #2c7be8;
  color: white;
  font-weight: bold;
  padding: 4px 0;
  text-align: center;
  font-size: 13px;
}

.bad-scroll{
    overflow-y:auto
}
.bad-scroll::-webkit-scrollbar {
    width: 4px;
    height: 1px;
}

.bad-scroll::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    background: #909090;
}
.bad-scroll::-webkit-scrollbar-track {/*滚动条里面轨道*/
    border-radius: 10px;
    background: #EDEDED;
}
</style>



// WEBPACK FOOTER //
// src/pages/fr/8d/component/1d.vue